import { createFileRoute, notFound } from "@tanstack/react-router";
import authStyles from "../styles/auth.css?url";
import { PasswordRecovery } from "../components/auth/password-recovery";
import { recoveryTarget } from "../lib/auth-route";
import { useShell } from "../lib/document-route";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { keepSearch } from "../lib/search";
import { isPlatformShell } from "../platform/shell";
import { loadRecovery } from "../server/auth";
import { useAuthSearch } from "../lib/published-auth";

/** Requesting a password reset link; never indexed. */
export const Route = createFileRoute("/forgot-password")({
  validateSearch: keepSearch,
  // A creator site's page only: Drate's own host has no account here.
  loader: async ({ parentMatchPromise }) => {
    if (isPlatformShell((await parentMatchPromise).loaderData)) throw notFound();
    await loadRecovery({ data: "/forgot-password" });
  },
  head: ({ matches }) => {
    const shell = shellFrom(matches);
    if (!shell) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: "/forgot-password",
        title: `Reset password | ${shell.creator.name}`,
        description: "Your content, your community, your corner of the internet.",
        noindex: true,
      }),
      authStyles,
    );
  },
  component: ForgotPassword,
});

function ForgotPassword() {
  const shell = useShell();
  const { query } = useAuthSearch(Route.useSearch(), !!shell.publication);
  return (
    <PasswordRecovery
      name={shell.creator.name}
      target={recoveryTarget(query.get("returnTo") || "/account")}
      sent={query.get("sent") === "1"}
      error={query.get("error") || undefined}
    />
  );
}
